import { Capacitor } from "@capacitor/core";
import { App as CapApp } from "@capacitor/app";
import {
    getAppToBackgroundAt,
    getLastHardReload,
    resetAppToBackgroundAt,
    setAppToBackgroundAt,
    setLastHardReload,
} from "./localStorage";
import { forceAppRefresh } from "./forceAppRefresh";
const MS_PER_SECOND = 1000;
const SECONDS_PER_MINUTE = 60;
const MINUTES_PER_HOUR = 60;
const MIN_HOURS = 6;

// Refresh mobile if coming back from background after 6 hours to prevent stale data.
// This is only relevant for the mobile app, and will not cause issues for web users.
// On native shells we also clear service worker state first, because Android can
// otherwise keep serving cached PWA assets even after a URL-based hard reload.

const registerResumeRefresh = () => {
    // Only run in native shells (iOS/Android). Never in normal web.
    if (!Capacitor.isNativePlatform()) return;

    // prevent double-registration
    const w = window as any;
    if (w.__resumeRefreshRegistered) return;
    w.__resumeRefreshRegistered = true;

    const MIN_MS = MIN_HOURS * MINUTES_PER_HOUR * SECONDS_PER_MINUTE * MS_PER_SECOND;

    CapApp.addListener("appStateChange", async ({ isActive }) => {
        if (!isActive) {
            setAppToBackgroundAt(Date.now());
            return;
        }

        const appToBackgroundAt = getAppToBackgroundAt();
        resetAppToBackgroundAt();

        if (!appToBackgroundAt) return;
        if (Date.now() - appToBackgroundAt < MIN_MS) return;

        const last = getLastHardReload();
        if (Date.now() - last < MIN_MS) return;

        setLastHardReload(Date.now());
        await forceAppRefresh();
    });
};

export default registerResumeRefresh;
